import {
  audiencesProductShowcase,
  intelligenceProductShowcase,
  journeysProductShowcase,
  realTimeProductShowcase,
} from "./product-showcase-screens";

const audiencesTab = {
  title: "Build any audience",
  description:
    "Enable marketers to use all of your data — not just users and events. Explore, build, and test any audience with a powerful no-code audience builder.",
  media: audiencesProductShowcase,
};

const journeysTab = {
  title: "Plan customer journeys",
  description:
    "Easily prioritize campaigns across your audiences. Ensure that customers experience cohesive marketing and get the right message at the right time.",
  media: journeysProductShowcase,
};

const realTimeTab = {
  title: "Personalize in real-time",
  description:
    "Use complete customer data and real-time signals to deliver personalized content in less than a second on your website and apps.",
  media: realTimeProductShowcase,
};

const splitsTab = {
  // TODO new splits media
  title: "Run better experiments",
  description:
    "Set up, execute, and measure A/B tests, multivariate tests, and hold-out groups with the accuracy of an analytics team — all on your own.",
};

const insightsTab = {
  title: "Uncover insights",
  description:
    "Use AI to measure, explore, and analyze customer data and campaign performance, directly from the data warehouse.",
  media: intelligenceProductShowcase,
};

export { audiencesTab, journeysTab, realTimeTab, insightsTab, splitsTab };
